<template>
  <div class="list-view product-checkout">
    <!-- Left Card -->
    <b-card no-body>
      <b-card-header class="flex-column align-items-start">
        <b-card-title>Validation</b-card-title>
        <b-card-text class="text-muted mt-25">
          Assurer vous que le récapitulatif respecte votre planification de
          sortie
        </b-card-text>
      </b-card-header>
      <b-card-body>
        <b-list-group v-if="plannedRelease.length > 0" flush>
          <b-list-group-item
              v-for="(release, i) in plannedRelease"
              :key="i"
              class="d-flex justify-content-between align-items-center"
          >
            <span>{{ i + 1 }}. {{ release.product.name }}</span>
            <b-badge variant="primary" pill class="badge-round">
              {{ release.qty }}
            </b-badge>
          </b-list-group-item>
        </b-list-group>
      </b-card-body>
    </b-card>

    <!-- Right Card -->
    <div class="amount-payable checkout-options">
      <b-card title="Détails de planification">
        <ul class="list-unstyled price-details">
          <li class="price-detail">
            <div class="details-title">Nbr. de sortie</div>
            <div class="detail-amt">
              <strong>{{ plannedRelease.length }} Produit(s)</strong>
            </div>
          </li>
          <li class="price-detail">
            <!--            <div class="details-title">Période</div>-->
            <div class="detail-amt discount-amt text-success">
              Du {{ moment(details.dispatch_date, "DD-MM-YYYY").format('LL') }} -
              Au {{ moment(details.return_date, "DD-MM-YYYY").format('LL') }}
            </div>
          </li>
        </ul>
        <hr/>
        <div>
          <b-button variant="primary" class="mb-1" @click="$emit('next-step')">
            Enregistrer
          </b-button>
        </div>
      </b-card>
    </div>
  </div>
</template>

<script>
import {
  BCard,
  BCardHeader,
  BCardTitle,
  BCardText,
  BCardBody,
  BButton,
  BRow,
  BCol,
  BBadge,
  BListGroupItem,
  BListGroup,
} from "bootstrap-vue";

import {formatDate} from "@core/utils/filter";
import store from "@/store";
import {computed} from "@vue/composition-api";
import moment from "moment";

moment.locale("fr");

export default {
  name: "StoreViewItemsCheckoutStepRecap",
  methods: {formatDate, moment},
  components: {
    BListGroup,
    BListGroupItem,
    BBadge,
    // BSV
    BCard,
    BCardHeader,
    BCardTitle,
    BCardText,
    BCardBody,
    BButton,
  },
  props: {
    details: {
      type: Object,
      required: true,
    },
  },
  setup(props, {emit}) {
    const plannedRelease = computed(() => store.getters["stock/release_products"]);

    return {
      plannedRelease,
    };
  },
};
</script>

<style lang="scss" scoped>
#cvv {
  width: auto;
}
</style>
